"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const callableSetAppValue = ({ entryVars: { key, value }, processor, }) => {
    if (!(0, valueIsString_1.default)(key)) {
        processor.root.alert('Invalid key to set app param', `${key}`);
        return;
    }
    processor.root.setAppParam(key, value);
};
exports.default = callableSetAppValue;
